import React, { useState, useRef } from 'react';
import ApiService from 'services/apiService';
import Spinner from 'components/common/spinner/spinner';
import _ from 'lodash';
import './appLoadingIndicator.css';

export default function AppLoadingIndicator(props) {
  const [isVisible, setIsVisible] = useState(false);

  const dispatchHide = useRef(
    _.debounce(() => setIsVisible(false), 20)
  ).current;

  const handleActiveCallsChanged = (count) => {
    if (count > 0) {
      dispatchHide.cancel();
      setIsVisible(true);
    }
    else {
      dispatchHide();
    }
  };

  ApiService.setActiveCallsUpdateCallback(handleActiveCallsChanged, true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className='app-spinner-overlay'>
      <div className='app-spinner-position'>
        <Spinner className='app-spinner' animation='circular' variant='rotate' />
        {/*<div className='text-dark'>Loading...</div>*/}
      </div>
    </div>
  );
}